"use client";

import { Bitcoin, Landmark, type LucideIcon } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { MOBILE_NAV } from "@/lib/navigation";

const ICONS: Record<string, LucideIcon> = {
  crypto: Bitcoin,
  macro: Landmark
};

export function MobileNav() {
  const { t } = useI18n();
  const pathname = window.location.pathname;

  return (
    <nav
      data-mobile-nav
      aria-label="Primary navigation"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-[var(--hc-border-strong)] bg-[var(--hc-surface-1)] px-2 pb-[max(8px,env(safe-area-inset-bottom))] pt-2 lg:hidden"
    >
      <div className="mx-auto grid max-w-xl grid-cols-2 gap-1">
        {MOBILE_NAV.map((item) => {
          const Icon = ICONS[item.icon];
          const current = item.href === "/" ? pathname === "/" : pathname.startsWith(item.href);
          return (
            <a
              key={item.id}
              href={item.href}
              aria-current={current ? "page" : undefined}
              className={`flex min-h-11 flex-col items-center justify-center gap-1 rounded-md px-1 text-[10px] font-semibold transition-colors ${
                current
                  ? "bg-[var(--hc-blue-soft)] text-[var(--hc-text)]"
                  : "text-[var(--hc-muted)] hover:bg-[var(--hc-surface-2)] hover:text-[var(--hc-text)]"
              }`}
            >
              <Icon size={18} strokeWidth={1.8} aria-hidden="true" />
              <span className="max-w-full truncate">{t(item.labelKey)}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
}
